import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LiveLandingPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [code, setCode] = useState('');
  const [error, setError] = useState(null);

  const handleJoin = (e) => {
    e.preventDefault();
    const normalized = code.trim().toUpperCase();
    if (!/^[A-Z0-9]{4,8}$/.test(normalized)) {
      setError('Le code de session doit contenir 4 à 8 caractères alphanumériques.');
      return;
    }
    setError(null);
    navigate(`/live/${normalized}`);
  };

  return (
    <div
      className="container"
      style={{
        marginTop: '2rem',
        maxWidth: 520,
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem'
      }}
    >
      <h1 style={{ margin: 0 }}>Exercice en direct</h1>
      <p style={{ color: '#7f8c8d', margin: 0 }}>
        Rejoignez une session animée en saisissant le code reçu, ou créez-en une nouvelle si vous êtes l'animateur.
      </p>

      <form onSubmit={handleJoin} className="card" style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <label htmlFor="live-code" style={{ fontWeight: 600 }}>Code de session</label>
        <input
          id="live-code"
          type="text"
          inputMode="text"
          autoCapitalize="characters"
          autoComplete="off"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Ex: K3X9P"
          style={{
            fontSize: '1.6rem',
            letterSpacing: '0.2em',
            textAlign: 'center',
            textTransform: 'uppercase',
            padding: '0.75rem',
            border: '2px solid #d6dde3',
            borderRadius: 8,
            fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace'
          }}
          maxLength={8}
        />
        {error && <div style={{ color: '#c0392b', fontSize: '0.9rem' }}>{error}</div>}
        <button type="submit" className="btn btn-primary" style={{ fontSize: '1.05rem', padding: '0.85rem' }}>
          Rejoindre
        </button>
      </form>

      <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <h3 style={{ margin: 0 }}>Animateur</h3>
        <p style={{ margin: 0, color: '#7f8c8d' }}>
          Vous voulez animer cet exercice avec un groupe ? Créez une nouvelle session — un code et un QR code seront générés pour vos participants.
        </p>
        {(isAuthenticated || process.env.NODE_ENV === 'development') ? (
          <Link to="/live/new" className="btn btn-primary">
            Créer une session
            {!isAuthenticated && process.env.NODE_ENV === 'development' && ' (dev)'}
          </Link>
        ) : (
          <Link to="/auth" className="btn btn-secondary">Se connecter pour créer une session</Link>
        )}
      </div>
    </div>
  );
}
